// extracted by mini-css-extract-plugin
export default {"score":"RepositoryScore_score__z5+4L","danger":"RepositoryScore_danger__fmFyn","warn":"RepositoryScore_warn__eEJqQ","ok":"RepositoryScore_ok__KqCTE"};